import type { ComponentProps } from "react";
import { FIELD_TYPES } from "@circle-react-shared/ProfileFields/constants";
import { SelectFieldFilter, TextFieldFilter } from "./FieldTypes";
import { LocationFieldFilter } from "./FieldTypes/LocationFieldFilter";

interface ProfileFieldFilterProps
  extends ComponentProps<typeof TextFieldFilter> {
  field_type: string;
}

const components: Record<
  string,
  typeof TextFieldFilter | typeof SelectFieldFilter | typeof LocationFieldFilter
> = {
  [FIELD_TYPES.TEXT]: TextFieldFilter,
  [FIELD_TYPES.LINK]: TextFieldFilter,
  [FIELD_TYPES.NUMBER]: TextFieldFilter,
  [FIELD_TYPES.TEXTAREA]: TextFieldFilter,
  [FIELD_TYPES.SELECT]: SelectFieldFilter,
  [FIELD_TYPES.CHECKBOX]: SelectFieldFilter,
  [FIELD_TYPES.LOCATION]: LocationFieldFilter,
};

export const ProfileFieldFilter = ({
  field_type: fieldType,
  ...rest
}: ProfileFieldFilterProps) => {
  const Component: any = components[fieldType] || (() => null);
  return <Component {...rest} />;
};
